const fr = {
  translation: {
    cancel: 'Annuler',
    welcome: 'Menu Scolaire',
    dashboard: 'Tableau de Bord',
    logout: 'Déconnexion',
    adminDashboard: 'Tableau de Bord Admin',
    viewPublicSite: 'Voir le Site Public',
    allSchools: 'Toutes les Écoles',
    profile: 'Profil',
    // Profile page translations
    profilePage: {
      title: 'Mon Profil',
      name: 'Nom',
      username: 'Nom d\'utilisateur',
      email: 'Email',
      nameRequired: 'Le nom est requis',
      usernameRequired: 'Le nom d\'utilisateur est requis',
      usernameInvalid: 'Le nom d\'utilisateur ne peut contenir que des lettres, des chiffres et des tirets bas',
      usernameHint: 'Utilisez uniquement des lettres, des chiffres et des tirets bas',
      emailRequired: 'L\'email est requis',
      emailInvalid: 'L\'email est invalide',
      emailInUse: 'Email déjà utilisé',
      usernameInUse: 'Nom d\'utilisateur déjà utilisé',
      saveChanges: 'Enregistrer les modifications',
      saving: 'Enregistrement...',
      checking: 'Vérification...',
      updateSuccess: 'Profil mis à jour avec succès',
      updateFailed: 'Échec de la mise à jour du profil',
      changePassword: 'Changer le mot de passe',
      changePasswordButton: 'Changer le mot de passe',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le nouveau mot de passe',
      currentPasswordRequired: 'Le mot de passe actuel est requis',
      newPasswordRequired: 'Le nouveau mot de passe est requis',
      passwordTooShort: 'Le mot de passe doit comporter au moins 12 caractères',
      passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
      incorrectPassword: 'Le mot de passe actuel est incorrect',
      passwordChangeSuccess: 'Mot de passe changé avec succès',
      passwordChangeFailed: 'Échec du changement de mot de passe',
      passwordRequirements: 'Minimum 12 caractères',
      updatePassword: 'Mettre à jour le mot de passe',
      changing: 'Changement...',
      cancel: 'Annuler'
    },
    // Landing page translations
    landing: {
      hero: {
        title: 'Simplifiez la Gestion des Menus Scolaires',
        subtitle: 'Créez, traduisez et partagez vos menus scolaires en plusieurs langues avec une plateforme facile à utiliser.',
        getStarted: 'Commencer Gratuitement',
        goToDashboard: 'Aller au Tableau de Bord',
        learnMore: 'En savoir plus'
      },
      features: {
        title: 'Tout ce dont Vous Avez Besoin pour la Gestion des Menus Scolaires',
        menuCreation: {
          title: 'Création de Menus',
          description: 'Créez des menus hebdomadaires ou mensuels avec notre éditeur intuitif. Ajoutez des plats, des cours et des informations sur les régimes spéciaux.'
        },
        translation: {
          title: 'Support Multilingue',
          description: 'Traduisez vos menus en plusieurs langues. Parfait pour les écoles internationales et les communautés diverses.'
        },
        sharing: {
          title: 'Sous-domaine Personnalisé',
          description: 'Partagez vos menus avec un sous-domaine personnalisé (votreécole.schoolmenus.xyz) pour un accès facile par les parents et les élèves.'
        },
        communityAccess: {
          title: 'Accès Facile pour la Communauté',
          description: 'Offrez aux parents et aux élèves un accès simple pour consulter les derniers menus depuis n\'importe quel appareil via une page publique dédiée.'
        }
      },
      cta: {
        title: 'Prêt à simplifier la gestion de vos menus scolaires ?',
        subtitle: 'Créez un compte ou connectez-vous pour commencer à gérer vos menus scolaires dès aujourd\'hui.',
      },
      footer: {
        about: 'À Propos de Nous',
        aboutText: 'School Menus est une plateforme dédiée à faciliter la planification et le partage des repas scolaires pour les écoles du monde entier.',
        links: 'Liens Rapides',
        features: 'Fonctionnalités',
        pricing: 'Tarifs',
        faq: 'FAQ',
        legal: 'Légal',
        privacy: 'Politique de Confidentialité',
        terms: 'Conditions d\'Utilisation',
        contact: 'Contactez-Nous',
        email: 'Email : info@schoolmenus.xyz',
        rights: 'Tous droits réservés.'
      },
      modal: {
        title: 'Merci de vous être abonné !',
        message: "Nous vous tiendrons informé des dernières fonctionnalités et actualités.",
        close: 'Fermer'
      },
      nav: {
        pricing: 'Tarifs'
      }
    },
    pricing: {
      title: 'Tarifs',
      earlyAccessDescription: 'Félicitations, vous êtes l\'une des premières personnes à découvrir schoolmenus.xyz ! Nous sommes encore en développement, ce qui signifie que les utilisateurs peuvent rencontrer des bugs ou des problèmes de performance de temps en temps (espérons-le mineurs).',
      freeUntilStable: 'En remerciement de votre patience, schoolmenus.xyz sera gratuit jusqu\'à ce qu\'une première version stable soit prête. À ce moment-là, des niveaux de tarification seront introduits, mais tous les utilisateurs existants seront récompensés par un abonnement gratuit d\'un an afin que vous puissiez continuer à utiliser schoolmenus.xyz au moins pour le reste de l\'année scolaire sans avoir à vous soucier de commencer à payer.'
    },
    common: {
      loading: 'Chargement...',
      save: 'Enregistrer',
      saving: 'Enregistrement...',
      cancel: 'Annuler',
      edit: 'Modifier',
      delete: 'Supprimer',
      create: 'Créer',
      search: 'Rechercher',
      filter: 'Filtrer',
      noData: 'Aucune donnée disponible',
      error: 'Erreur',
      retry: 'Réessayer',
      new: 'Nouveau',
      confirm: 'Confirmer',
      close: 'Fermer',
      add: 'Ajouter',
      remove: 'Retirer',
      upload: 'Télécharger',
      download: 'Télécharger',
      yes: 'Oui',
      no: 'Non',
      back: 'Retour',
      next: 'Suivant',
      all: 'Tous',
      none: 'Aucun',
      welcome: 'Bienvenue',
      logout: 'Déconnexion',
      login: 'Connexion',
      register: 'S\'inscrire',
      username: 'Nom d\'utilisateur',
      usernameOrEmail: 'Nom d\'utilisateur ou Email',
      password: 'Mot de passe',
      email: 'Email',
      name: 'Nom',
      description: 'Description',
      success: 'Succès',
      warning: 'Avertissement',
      info: 'Info',
      home: 'Accueil',
      settings: 'Paramètres',
      profile: 'Profil',
      dashboard: 'Tableau de Bord',
      summary: 'Résumé',
      details: 'Détails',
      view: 'Voir',
      update: 'Mettre à jour',
      help: 'Conseils Utiles',
      'Back to Dashboard': 'Retour au Tableau de Bord',
      loadingTranslations: 'Chargement des traductions...',
      saveSelectedTags: 'Enregistrer les Étiquettes Sélectionnées',
      accept: 'Accepter'
    },
    navbar: {
      home: 'Accueil',
      menu: 'Menu',
      admin: 'Admin',
      login: 'Connexion',
      logout: 'Déconnexion',
      settings: 'Paramètres',
      createMenu: 'Créer Menu',
      dishLibrary: 'Bibliothèque de Plats',
      translations: 'Traductions',
      specialNames: 'Noms de Jours Spéciaux',
      confirmNavigation: 'Quitter cette page ?',
      unsavedChanges: 'Vous avez des modifications non enregistrées. Si vous quittez maintenant, vos modifications seront perdues. Veuillez enregistrer votre travail avant de quitter ou appuyez sur "Quitter" pour annuler vos modifications.',
      dashboard: 'Tableau de Bord',
      leave: 'Quitter',
      cancel: 'Annuler',
      schoolHomepage: 'Page d\'accueil de l\'école'
    },
    home: {
      welcome: 'Bienvenue sur l\'App de Menu Scolaire',
      viewMenu: 'Voir le Menu',
      aboutSchool: 'À Propos de Notre École',
      contactUs: 'Contactez-Nous'
    },
    login: 'Connexion',
    loginPage: {
      email: 'Email',
      password: 'Mot de passe',
      loginButton: 'Connexion',
      loginError: 'Email ou mot de passe invalide',
      forgotPassword: 'Mot de passe oublié ?'
    },
    menu: {
      today: 'Menu du Jour',
      week: 'Menu de la Semaine',
      noItems: 'Aucun élément de menu disponible',
      loading: 'Chargement du menu...',
      download: 'Télécharger PDF',
      print: 'Imprimer le Menu',
      dashboard: 'Tableau de Bord',
      leave: 'Quitter',
      favorites: 'Favoris',
      schoolHomepage: 'Page d\'accueil de l\'école',
      title: 'Menu Scolaire - {{month}}',
      menuType: 'Type de Menu',
      selectMenuType: 'Sélectionner le Type de Menu',
      courses: 'Plats',
      day: 'Jour',
      firstCourse: 'Premier Plat',
      secondCourse: 'Deuxième Plat',
      dessert: 'Dessert',
      dishNotTranslated: 'Plat non encore traduit',
      schoolLunchMenu: 'Menu Scolaire',
      footer: 'Le menu est sujet à modification en fonction de la disponibilité des ingrédients',
      observations: 'Observations',
      noMenu: 'Aucun Menu Disponible',
      noMenuTypes: 'Chargement des types de menu...',
      loadingMenu: 'Chargement du menu...',
      noMenuForType: 'Ce type de menu n\'a pas de menu pour le mois en cours',
      noMenusAvailable: 'Aucun menu n\'est disponible pour le mois en cours',
      checkingAvailableMenus: 'Vérification des menus disponibles...',
      'There is no menu available for the current month.': 'Aucun menu n\'est disponible pour le mois en cours.',
      createThisMenu: 'Créer ce menu',
      editThisMenu: 'Modifier ce menu',
      notAvailable: 'Non Disponible',
      'Month/Year': 'Mois/Année',
      'Please select a menu type first': 'Veuillez d\'abord sélectionner un type de menu',
      nutrientDataIncomplete: 'Information nutritionnelle indisponible',
      nutrientDataComplete: 'Information nutritionnelle complète',
      weekNumber: 'Semaine {{week}}',
      weekShort: 'Semaine',
      previousWeek: 'Semaine Précédente',
      nextWeek: 'Semaine Suivante',
    },
    admin: {
      dashboard: 'Tableau de Bord Admin',
      menus: 'Menus',
      dishes: 'Plats',
      dish: 'Plat',
      recentMenus: 'Menus Récents',
      month: 'Mois',
      actions: 'Actions',
      editTranslations: 'Modifier les Traductions',
      enterTranslation: 'Saisir la Traduction',
      searchReplacement: 'Rechercher un remplacement',
      loadingMenu: 'Chargement du Menu',
      itemsToTranslate: 'Éléments à traduire',
      progress: 'Progrès',
      missingLanguages: 'Langues manquantes',
      skipItem: 'Ignorer l\'élément',
      thisWillOnlyTakeAMoment: 'Cela ne prendra qu\'un moment',
      noMissingTranslations: 'Aucune traduction manquante',
      allTranslationsComplete: 'Toutes les traductions sont complètes',
      courses: 'Plats',
      menuTypes: 'Types de Menu',
      schools: 'Écoles',
      users: 'Utilisateurs',
      settings: 'Paramètres',
      createMenu: 'Créer Menu',
      editMenu: 'Modifier Menu',
      createDish: 'Créer Plat',
      editDish: 'Modifier Plat',
      createCourse: 'Créer Plat',
      editCourse: 'Modifier Plat',
      createMenuType: 'Créer Type de Menu',
      editMenuType: 'Modifier Type de Menu',
      createSchool: 'Créer École',
      editSchool: 'Modifier École',
      createUser: 'Créer Utilisateur',
      editUser: 'Modifier Utilisateur',
      deleteMenu: 'Supprimer Menu',
      deleteDish: 'Supprimer Plat',
      deleteCourse: 'Supprimer Plat',
      deleteMenuType: 'Supprimer Type de Menu',
      deleteSchool: 'Supprimer École',
      deleteUser: 'Supprimer Utilisateur',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet {{item}} ?',
      confirmDeleteItem: 'Supprimer {{item}}',
      cancel: 'Annuler',
      delete: 'Supprimer',
      save: 'Enregistrer',
      create: 'Créer',
      edit: 'Modifier',
      view: 'Voir',
      back: 'Retour',
      next: 'Suivant',
      previous: 'Précédent',
      selectAll: 'Tout Sélectionner',
      deselectAll: 'Tout Désélectionner',
      search: 'Rechercher',
      filter: 'Filtrer',
      sort: 'Trier',
      ascending: 'Ascendant',
      descending: 'Descendant',
      noResults: 'Aucun résultat trouvé',
      error: 'Erreur',
      success: 'Succès',
      warning: 'Avertissement',
      info: 'Info',
      // Menu Management
      menuManagement: 'Gestion des Menus',
      menuName: 'Nom du Menu',
      menuType: 'Type de Menu',
      menuDate: 'Date du Menu',
      menuStatus: 'Statut du Menu',
      menuCreatedAt: 'Créé le',
      menuUpdatedAt: 'Mis à jour le',
      menuCreatedBy: 'Créé par',
      menuUpdatedBy: 'Mis à jour par',
      menuActions: 'Actions',
      menuEditor: 'Éditeur de Menu',
      menuEditorDesc: 'Créer et gérer les menus scolaires mensuels',
      translationEditor: 'Éditeur de Traduction',
      translationEditorDesc: 'Gérer les traductions pour les plats et autres éléments',
      translationQueue: 'File d\'attente de Traduction',
      translationQueueDesc: 'Traduire efficacement plusieurs éléments',
      nutrientQueue: 'File d\'attente de Nutriments',
      nutrientQueueDesc: 'Saisir les informations nutritionnelles pour les plats',
      tagQueue: 'File d\'attente d\'Étiquettes',
      tagQueueDesc: 'Gérer efficacement les informations sur les étiquettes pour plusieurs plats',
      settingsDesc: 'Gérer les paramètres de l\'école, les utilisateurs et les configurations système',
      // Copying Menu
      copyMenu: 'Copier le Menu',
      copyFromCurrentToNew: 'Copier ce menu vers un nouveau type de menu pour {{month}}',
      copyFromExistingToNew: 'Copier à partir d\'un menu existant pour {{month}}',
      selectTargetMenuType: 'Sélectionner le type de menu cible',
      selectSourceMenuType: 'Sélectionner le type de menu source',
      selectMenuType: 'Sélectionner un type de menu...',
      noAvailableMenuTypes: 'Tous les types de menu ont déjà un menu pour ce mois',
      noExistingMenus: 'Aucun type de menu n\'a encore de menu pour ce mois',
      errorFetchingMenuTypes: 'Erreur lors de la récupération des types de menu',
      errorCopyingMenu: 'Erreur lors de la copie du menu',
      // Intelligent Substitution Feature
      useIntelligentSubstitution: 'Tenter la substitution historique des plats',
      intelligentSubstitutionTooltip: 'Utilise les données historiques pour faire correspondre intelligemment les plats entre les types de menu en fonction des modèles d\'utilisation passés.',
      // Notifications
      menuCreated: 'Menu créé avec succès',
      menuUpdated: 'Menu mis à jour avec succès',
      menuDeleted: 'Menu supprimé avec succès',
      specialDayPlaceholder: 'Saisir le nom du jour spécial',
      dishCreated: 'Plat créé avec succès',
      dishUpdated: 'Plat mis à jour avec succès',
      dishDeleted: 'Plat supprimé avec succès',
      courseCreated: 'Cours créé avec succès',
      courseUpdated: 'Cours mis à jour avec succès',
      courseDeleted: 'Cours supprimé avec succès',
      menuTypeCreated: 'Type de menu créé avec succès',
      menuTypeUpdated: 'Type de menu mis à jour avec succès',
      menuTypeDeleted: 'Type de menu supprimé avec succès',
      schoolCreated: 'École créée avec succès',
      schoolUpdated: 'École mise à jour avec succès',
      schoolDeleted: 'École supprimée avec succès',
      userCreated: 'Utilisateur créé avec succès',
      userUpdated: 'Utilisateur mis à jour avec succès',
      userDeleted: 'Utilisateur supprimé avec succès',
      // Day names
      noCourses: 'Aucun cours disponible',
      noCoursesMessage: 'Ce type de menu n\'a aucun cours associé. Veuillez configurer les cours pour ce type de menu dans la page Paramètres avant de créer un menu.',
      preview: 'Aperçu',
      copy: 'Copier',
      // ... existing translations ...
      saveChanges: 'Enregistrer les Modifications',
      saveCustomContent: 'Enregistrer le Contenu Personnalisé',
      saveBranding: 'Enregistrer l\'Image de Marque',
    },
    dishes: {
      add: 'Ajouter Plat',
      edit: 'Modifier Plat',
      name: 'Nom',
      description: 'Description',
      type: 'Type',
      tags: 'Étiquettes',
      search: 'Rechercher Plats'
    },
    calendar: {
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      sunday: 'Dimanche',
      january: 'Janvier',
      february: 'Février',
      march: 'Mars',
      april: 'Avril',
      may: 'Mai',
      june: 'Juin',
      july: 'Juillet',
      august: 'Août',
      september: 'Septembre',
      october: 'Octobre',
      november: 'Novembre',
      december: 'Décembre'
    },
    general: {
      loading: 'Chargement...',
      save: 'Enregistrer',
      saving: 'Enregistrement...',
      cancel: 'Annuler',
      edit: 'Modifier',
      delete: 'Supprimer',
      create: 'Créer',
      search: 'Rechercher',
      filter: 'Filtrer',
      noData: 'Aucune donnée disponible',
      error: 'Erreur',
      retry: 'Réessayer',
      checkServerStatus: 'Vérifier l\'état du serveur',
      dish: 'Plat',
      specialName: 'Nom de Jour Spécial',
      close: 'Fermer',
      accept: 'Accepter'
    },
    modal: {
      cancel: 'Annuler',
      delete: 'Supprimer',
      deletePrompt: 'Êtes-vous sûr de vouloir supprimer {dish} ?',
      confirmDelete: 'Confirmer la Suppression',
      changeUntranslatedSpecialName: 'Changer le nom spécial non traduit',
      changeUntranslatedDish: 'Changer le plat non traduit',
      untranslatedSpecialName: 'Ce nom spécial n\'est pas encore traduit en français. Souhaitez-vous le changer pour autre chose ? Accepter supprimera ce nom spécial de ce jour.',
      untranslatedDish: 'Ce plat n\'est pas encore traduit en français. Souhaitez-vous le changer pour autre chose ? Accepter supprimera ce plat de ce jour.',
      dishInUse: 'Ce plat est utilisé dans {{count}} éléments de menu.',
      specialNameInUse: 'Ce nom spécial est utilisé dans {{count}} jours.',
      selectReplacementDish: 'Veuillez sélectionner un plat de remplacement à utiliser dans tous les menus concernés.',
      selectReplacementSpecialName: 'Veuillez sélectionner un nom spécial de remplacement à utiliser dans tous les jours concernés.',
      replacementRequired: 'Un remplacement est requis pour supprimer cet élément.',
      confirmDeleteDish: 'Êtes-vous sûr de vouloir supprimer ce plat ? Cette action est irréversible.',
      confirmDeleteSpecialName: 'Êtes-vous sûr de vouloir supprimer ce nom spécial ? Cette action est irréversible.',
      deleteAndReplace: 'Supprimer et Remplacer',
      deletePermanently: 'Supprimer Définitivement',
      validReplacementSelected: 'Remplacement valide sélectionné',
      confirmDeleteMenu: 'Confirmer la Suppression du Menu',
      deleteMenuWarning: 'Êtes-vous sûr de vouloir supprimer ce menu ?',
      actionCannotBeUndone: 'Cette action est irréversible.',
      allMenuDaysWillBeDeleted: 'Tous les jours de ce menu seront supprimés.',
      allMenuItemsWillBeDeleted: 'Tous les éléments de ce menu seront supprimés.',
      deleteMenu: 'Supprimer le Menu'
    },
    languages: {
      en: 'English',
      ca: 'Catalan',
      es: 'Spanish',
      fr: 'French'
    },
    settings: {
      title: 'Paramètres',
      manageUsers: 'Gérer les Utilisateurs',
      users: 'Utilisateurs',
      menuTypes: 'Types de Menu',
      courses: 'Plats',
      nutrients: 'Nutriments',
      schoolInfo: 'Informations sur l\'École',
      webhooks: 'Webhooks',
      addUser: 'Ajouter Utilisateur',
      editUser: 'Modifier Utilisateur',
      deleteUser: 'Supprimer Utilisateur',
      userName: 'Nom',
      userEmail: 'Email',
      userUsername: 'Nom d\'utilisateur',
      userRoles: 'Rôles',
      userRole: 'Rôle',
      userPassword: 'Mot de passe',
      userSave: 'Enregistrer Utilisateur',
      confirmDeleteUser: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
      userDeleted: 'Utilisateur supprimé avec succès',
      errorDeletingUser: 'Erreur lors de la suppression de l\'utilisateur',
      userSaved: 'Utilisateur enregistré avec succès',
      errorSavingUser: 'Erreur lors de l\'enregistrement de l\'utilisateur',

      // User management
      roles: 'Rôles',
      inviteUser: 'Inviter Utilisateur',
      invite: 'Inviter',
      inviting: 'Invitation en cours...',
      emailRequired: 'L\'email est requis',
      roleRequired: 'Au moins un rôle doit être sélectionné',
      userNotExist: 'Cet utilisateur n\'existe pas. Il doit d\'abord créer un compte',
      userInvited: 'Utilisateur invité à l\'école avec succès',
      errorInvitingUser: 'Erreur lors de l\'invitation de l\'utilisateur',
      superadmin: 'Superadmin',
      admin: 'Admin',
      editor: 'Éditeur',
      viewer: 'Lecteur',
      userRolesUpdated: 'Rôles utilisateur mis à jour avec succès',
      errorUpdatingRoles: 'Erreur lors de la mise à jour des rôles utilisateur',
      remove: 'Retirer',
      userRemoved: 'Utilisateur retiré de l\'école avec succès',
      errorRemovingUser: 'Erreur lors du retrait de l\'utilisateur de l\'école',
      enterEmail: 'Saisir l\'adresse email',
      selectRoles: 'Sélectionner les Rôles',
      updateRoles: 'Mettre à jour les Rôles',
      superadminOnly: 'Superadmin uniquement',
      cannotRemoveAdmin: 'Seuls les superadmins peuvent retirer les utilisateurs admin ou superadmin',
      restrictedAccess: 'Accès restreint',
      noUsers: 'Aucun utilisateur trouvé',
      errorFetchingUsers: 'Erreur lors de la récupération des utilisateurs',
      roleExplanation: 'Permissions des Rôles',
      superadminDesc: 'Accès complet à cette école, peut assigner tous les rôles y compris admin et superadmin',
      adminDesc: 'Accès complet à cette école, ne peut pas assigner/retirer admin/superadmin',
      editorDesc: 'Peut modifier les menus et le contenu mais pas les utilisateurs',
      viewerDesc: 'Accès en lecture seule',

      schoolName: 'Nom de l\'École',
      subdomain: 'Sous-domaine',
      homepageUrl: 'URL de la Page d\'Accueil',
      showNutrients: 'Afficher les Informations Nutritionnelles',
      defaultLanguage: 'Langue par Défaut',
      saveBasicInfo: 'Enregistrer les Informations de Base',
      schoolInfoSaved: 'Informations sur l\'école enregistrées avec succès',
      errorSavingSchoolInfo: 'Erreur lors de l\'enregistrement des informations sur l\'école',
      logo: 'Logo',
      uploadLogo: 'Télécharger le Logo',
      logoUploaded: 'Logo téléchargé avec succès',
      errorFetching: 'Erreur lors de la récupération des paramètres',
      subdomainLocked: 'Contacter le support pour changer le sous-domaine',
      schoolColors: 'Couleurs de l\'École',
      primaryBgColor: 'Couleur de Fond Principale',
      primaryTextColor: 'Couleur de Texte Principale',
      secondaryBgColor: 'Couleur de Fond Secondaire',
      secondaryTextColor: 'Couleur de Texte Secondaire',
      
      // Menu Type specific translations
      menuType: 'Type de Menu',
      menuTypeVisibility: 'Visibilité du Type de Menu',
      showMenuTypePublicly: 'Afficher ce type de menu dans le menu public',
      visibilityExplanation: 'Lorsque cette option est activée, ce type de menu sera affiché dans la visionneuse de menu public',
      menuTypeOptions: 'Options d\'Affichage',
      showNutrientsForMenuType: 'Afficher les informations nutritionnelles pour ce type de menu',
      showTagsForMenuType: 'Afficher les informations sur les étiquettes pour ce type de menu',
      nutrientTagExplanation: 'Ces paramètres contrôlent si les informations nutritionnelles et sur les étiquettes sont affichées pour ce type de menu, en plus des paramètres au niveau de l\'école.',
      menuTypeSaved: 'Type de menu enregistré avec succès',
      menuTypeDeleted: 'Type de menu supprimé avec succès',
      errorSavingMenuType: 'Erreur lors de l\'enregistrement du type de menu',
      errorDeletingMenuType: 'Erreur lors de la suppression du type de menu',
      menuTypeInUseExplanation: 'Vous devez modifier le type de menu dans ces menus avant de pouvoir le supprimer',
      noNutrients: 'Aucun Nutriment',
      noTags: 'Aucune Étiquette',
      noTranslationAvailable: 'Aucune traduction disponible',
      enterTranslation: 'Saisir la traduction',
      requiredTranslation: 'Traduction requise',
      defaultLanguageField: 'Champ de langue par défaut',
      usingFallbackTranslation: 'Utilisation de la traduction de repli',
      
      // Delete confirmations
      deleteMenuTypeConfirmation: 'Supprimer le Type de Menu',
      deleteCourseConfirmation: 'Supprimer le Plat',
      confirmDeleteMenuType: 'Êtes-vous sûr de vouloir supprimer le type de menu "{name}" ?',
      confirmDeleteCourse: 'Êtes-vous sûr de vouloir supprimer le plat "{name}" ?',
      cannotDeleteMenuTypeInUse: 'Ce type de menu est utilisé dans {count} menus et ne peut pas être supprimé.',
      cannotDeleteCourseInUse: 'Ce plat est utilisé dans {count} éléments de menu et ne peut pas être supprimé.',
      courseInUseExplanation: 'Vous devez supprimer ou remplacer ce plat dans tous les menus avant de pouvoir le supprimer.',
      
      // Subdomain-related translations
      checkingAvailability: 'Checking availability...',
      subdomainEmpty: 'Subdomain cannot be empty',
      subdomainInvalidFormat: 'Invalid format. Use lowercase letters, numbers, and hyphens. Cannot start or end with a hyphen.',
      subdomainCheckError: 'Error checking subdomain availability',
      waitForSubdomainCheck: 'Please wait while we check the subdomain availability',
      subdomainNotAvailable: 'This subdomain is not available',
      subdomainChanged: 'Subdomain updated successfully! DNS changes may take time to propagate.',
      subdomainCooldown: 'Subdomain Change Cooldown Period',
      cooldownWillEndOn: 'You can change your subdomain again on {{date}} at {{time}}.',
      subdomainChangeMessage: 'Your subdomain was changed within the last 14 days. You can change it again in 14 days.',
      dnsNoteHeading: 'Important note about subdomain changes:',
      dnsNote1: 'It may take up to 30 minutes for DNS changes to propagate across the internet.',
      dnsNote2: 'During this time, some users may still access your site through the previous subdomain.',
      dnsNote3: 'Your previous subdomain will continue to redirect to your new subdomain for 7 days.',
      
      languages: 'Languages',
      manageLanguages: 'Manage Languages',
      availableLanguages: 'Available languages',
      languagesSaved: 'Languages saved successfully',
      selectDefaultLanguage: 'Select a default language',
      
      // Navigation and common UI elements
      welcome: 'School Menu',
      dashboard: 'Dashboard',
      logout: 'Logout',
      schoolHomepage: 'School Website',
      
      // User roles for display
      admin: 'Administrator',
      editor: 'Editor',
      viewer: 'Viewer',
      
      noLanguagesSelected: 'No languages selected',
      languagesDescription: 'Select which languages your school will use',
      menuTypesDescription: 'Menu types define the structure of your menus',
      name: 'Name',
      email: 'Email',
      role: 'Role',
      actions: 'Actions',
      edit: 'Edit',
      delete: 'Delete',
      add: 'Add',
      addNewUser: 'Add New User',
      addNewMenuType: 'Add New Menu Type',
      addNewCourse: 'Add New Course',
      saveChanges: 'Save Changes',
      saveCustomContent: 'Enregistrer le Contenu Personnalisé',
      saveBranding: 'Save Branding',
      saveDisplayOptions: 'Save Display Options',
      schoolInformation: 'School Information',
      contactEmail: 'Contact Email',
      contactPhone: 'Contact Phone',
      primaryColor: 'Primary Color',
      secondaryColor: 'Secondary Color',
      manageMenuTypes: 'Manage Menu Types',
      manageCourses: 'Manage Courses',
      menuTypeVisibility: 'Menu Type Visibility',
      showMenuTypePublicly: 'Show this menu type in public menu',
      visibilityExplanation: 'When enabled, this menu type will be shown in the public menu viewer',
      hidden: 'Hidden',
      
      // Missing translation keys
      translations: 'Translations',
      defaultLanguageField: 'Default language - required',
      requiredTranslation: 'Required - enter translation',
      languagesExplanation: 'Select which languages you want to activate for your school. Only selected languages will be shown to users.',
      defaultLanguageExplanation: 'Select the default language for your school. This language will be shown initially to all users who have not selected a language preference.',
      languageWarning: 'Note: Disabling a language will hide it from the language switcher, but existing translations will be preserved.',
      basicInformation: 'Informations de Base',
      customContent: 'Description de l\'École',
      customContentPlaceholder: 'Entrez une description de votre école à afficher sur la page d\'accueil',
      customContentSaved: 'Contenu personnalisé enregistré avec succès',
      errorSavingCustomContent: 'Erreur lors de l\'enregistrement du contenu personnalisé',
      disclaimerText: 'Texte de Clause de Non-Responsabilité',
      disclaimerTextPlaceholder: 'Entrez le texte de clause de non-responsabilité pour les images de menu...',
      saveDisclaimerText: 'Enregistrer le Texte de Clause de Non-Responsabilité',
      disclaimerTextSaved: 'Texte de clause de non-responsabilité enregistré avec succès',
      errorSavingDisclaimerText: 'Erreur lors de l\'enregistrement du texte de clause de non-responsabilité',
      includeCustomContentInImage: 'Inclure le contenu personnalisé dans les images de menu',
      includeCustomContentInImageExplanation: 'Contrôle si le contenu personnalisé apparaît dans les images avec le menu quotidien téléchargé depuis la page de prévisualisation de menus.',
      branding: 'Image de Marque',
      schoolLogo: 'Logo de l\'École',
      logoNote: 'Taille recommandée : 200x200px. Taille maximale : 2MB. Formats acceptés : JPG, PNG, GIF, SVG.',
      
      // Menu Type Management
      defaultMenuType: 'Default Menu Type',
      defaultMenuTypeExplanation: 'Select which menu type will be shown by default in the menu viewer',
      selectDefaultMenuType: 'Select a default menu type',
      updateDefaultMenuType: 'Update Default',
      defaultMenuTypeUpdated: 'Default menu type updated successfully',
      errorUpdatingDefaultMenuType: 'Error updating default menu type',
      coursesForMenuType: 'Courses for this Menu Type',
      loadingCourses: 'Loading courses...',
      noCoursesForMenuType: 'No courses assigned to this menu type',
      addCourseToMenuType: 'Add Course to Menu Type',
      noAvailableCourses: 'No courses available to add',
      selectCourse: 'Select a course',
      moveUp: 'Move Up',
      moveDown: 'Move Down',
      removeCourse: 'Remove Course',
      courseAddedToMenuType: 'Course added to menu type successfully',
      courseRemovedFromMenuType: 'Course removed from menu type successfully',
      errorAddingCourseToMenuType: 'Error adding course to menu type',
      errorRemovingCourseFromMenuType: 'Error removing course from menu type',
      course: 'Course',
      deleteCourseConfirmation: 'Delete Course',
      confirmDeleteCourse: 'Are you sure you want to delete course "{name}"?',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      defaultLanguageRequired: 'A default language must be selected',
      defaultLanguageMustBeSelected: 'The default language must be one of the selected languages',
      errorSavingDefaultLanguage: 'Error saving default language',
      requiredLanguage: 'Required language',
      noMenuTypesAvailable: 'No menu types available. Create a menu type first.',
      noTranslationsAvailable: 'No translations available',
      noCourses: 'No courses available',
      atLeastOneLanguage: 'Please select at least one language',
      defaultMustBeSelected: 'The default language must be included in the selected languages',
      errorReorderingCourse: 'Error reordering course',
      courseReordered: 'Course reordered successfully',
      errorFetchingMenuTypeCourses: 'Error fetching courses for menu type',
      errorUpdatingCourse: 'Error updating course',
      
      // Month Navigation Settings
      monthNavigation: {
        title: 'Public Navigation Settings',
        description: 'Allow public users to navigate between periods (months or weeks) in the menu viewer.',
        enable: 'Enable Public Navigation',
        monthsBack: 'Periods Back Allowed',
        monthsAhead: 'Periods Ahead Allowed',
        daysAfterStart: 'Days Allowed to Go Back (After Period Start)',
        daysBeforeEnd: 'Days Allowed to Go Forward (Before Period End)',
        saveSettings: 'Save Navigation Settings',
        invalidNumber: 'Please enter a valid number',
        mustBePositive: 'Value must be zero or positive',
        tooManyMonths: 'Value cannot exceed {{max}} periods',
        tooManyDays: 'Value cannot exceed {{max}} days',
        maxMonthsRange: 'Maximum {{max}} periods',
        maxDaysRange: 'Maximum {{max}} days',
        // New keys for the display type toggle
        displayType: 'Display Type',
        weekly: 'Weekly',
        monthly: 'Monthly',
        monthlyDescription: 'The public menu will display a full month at a time.',
        weeklyDescription: 'The public menu will display a week at a time.'
      },
      
      // Confirmation Modals
      confirmationModal: {
        title: 'Confirm Changes',
        saveChanges: 'Save Changes',
        discardChanges: 'Discard Changes',
        unsavedChangesWarning: 'You have unsaved changes. Are you sure you want to leave this page?',
        leavePage: 'Leave Page',
        stayOnPage: 'Stay on Page'
      },
      enterTranslation: 'Enter translation here...',
      save: 'Save',
      errorFetchingTranslations: 'Error fetching translations.',
      errorUpdatingMenuType: 'Error updating menu type.',
      confirmDeleteUser: 'Confirm User Deletion',
      manageUsers: 'Manage Users',
      menuTypeUpdated: 'Menu type updated successfully.',
      courseUpdated: 'Course updated successfully.',
      deleteCourse: 'Delete Course',
      customContentSaved: 'Custom content saved successfully.',
      tags: 'Étiquettes',
      general: 'General',
      appearance: 'Appearance',
      account: 'Account',
      notifications: 'Notifications',
      languageSettings: 'Language Settings',
      addLanguage: 'Add Language',
      languageName: 'Language Name',
      languageCode: 'Language Code',
      languageNativeName: 'Native Name',
      editLanguage: 'Edit Language',
      deleteLanguage: 'Delete Language',
      deleteLanguageConfirmation: 'Are you sure you want to delete this language? All associated translations will be lost.',
      languageInUse: 'This language is currently in use for menus or dishes and cannot be deleted.',
      languageAdded: 'Language added successfully.',
      languageUpdated: 'Language updated successfully.',
      languageDeleted: 'Language deleted successfully.',
      failedToAddLanguage: 'Failed to add language.',
      failedToUpdateLanguage: 'Failed to update language.',
      failedToDeleteLanguage: 'Failed to delete language.',
      billing: 'Billing',
      menuTypes: 'Menu Types',
      addMenuType: 'Add New Menu Type',
      editMenuType: 'Edit Menu Type',
    },
    upload: {
      fileTooLarge: 'File is too large. Maximum size is {{maxSize}}MB.',
      invalidFileType: 'Invalid file type. Please upload an image file.',
      errorReadingFile: 'Error reading file. Please try again.',
      dragAndDrop: 'Drag and drop file here',
      or: 'or',
      browse: 'browse files',
      maxSizeNote: 'Max. file size: {{maxSize}}MB',
      acceptedFormatsNote: 'Accepted formats'
    },
    preview: 'Preview',
    remove: 'Remove',
    // Language names
    languageNames: {
      en: 'Anglais',
      ca: 'Catalan',
      es: 'Espagnol',
      fr: 'Français'
    },
    translations: {
      bulkTranslations: 'Traductions en Masse',
      individualTranslations: 'Traductions Individuelles',
      step1: 'Step 1: Export Pending Translations',
      step2: 'Step 2: Complete Translations in Excel',
      step3: 'Step 3: Validate and Import',
      exportDescription: 'Download an Excel file with all items that need translation. Complete the missing translations in the file.',
      uploadDescription: 'Upload your completed Excel file with translations.',
      validateDescription: 'Check your translations and import them to the database.',
      selectFile: 'Select Translation File',
      exportTranslations: 'Export Translations',
      exportPendingTranslations: 'Export pending translations',
      exportAllTranslations: 'Export all translations',
      exporting: 'Exporting...',
      validating: 'Validating...',
      validateAndImport: 'Validate & Import',
      confirmImport: 'Confirm Import',
      fileValid: 'File Validation Successful',
      readyToImport: 'The translations file is valid and ready to be imported.',
      importing: 'Importing...',
      validationResults: 'Validation Results',
      importResults: 'Import Results',
      validationSummary: 'Summary of the translations validation',
      importSummary: 'Summary of the translations import operation',
      totalItems: 'Total Items',
      totalTranslations: 'Total Translations',
      itemsProcessed: 'Items Processed',
      translationsCreated: 'Translations Created',
      translationsUpdated: 'Translations Updated',
      warningsFound: 'There {{count, plural, one {is # warning} other {are # warnings}}}',
      rowError: 'Row {{row}}',
      moreErrors: 'and {{count}} more errors',
      importSuccess: 'Import Successful',
      exportError: 'Error exporting translations: {{error}}',
      importError: 'Error importing translations: {{error}}',
      validationError: 'Validation Error',
      validationErrorDetails: 'The uploaded file could not be validated due to the following issue:',
      fileEmpty: 'The file appears to be empty or has an invalid format.',
      requiredColumnsNotFound: 'Required columns (ID, Type, Reference Name) were not found in the file.',
      noLanguageColumns: 'No valid language columns were found in the file.',
      wrongFileFormat: 'The file might be in the wrong format. Please use the template from the "Export Translations" step.',
      fileStructureExample: 'The file should have language columns first (like "English", "Spanish", "Catalan"), followed by "ID", "Type", and "Reference Name" columns.',
      tryExportFirst: 'Try exporting a template file first, then add your translations to it rather than creating a file from scratch.',
      toBeCreated: 'To Be Created',
      toBeUpdated: 'To Be Updated',
      detailedChanges: 'Detailed Changes',
      name: 'Name',
      type: 'Type',
      language: 'Language',
      from: 'From',
      to: 'To',
      notSet: 'Not set',
      showingFirstN: 'Showing first {{count}} items',
      newTranslationsHeading: 'Items with New Translations',
      updatedTranslationsHeading: 'Items with Updated Translations',
      unchangedTranslationsHeading: 'Items with Unchanged Translations',
      item: 'Item'
    },
    fileUploader: {
      dragDrop: 'Drag and drop your file here',
      or: 'or',
      browse: 'browse files',
      acceptedTypes: 'Accepted file types',
      maxSize: 'Maximum size',
      fileSelected: 'File selected. Click to replace.',
      clear: 'Clear',
      invalidType: 'Invalid file type. Please select one of: {{acceptedTypes}}',
      fileTooLarge: 'File is too large. Maximum size is {{maxSize}} MB',
      clickToReplace: 'Click or drag to replace',
      currentFile: 'Current file',
      fileError: 'There was an error with the file'
    },
    loginToSchool: 'Login to {{schoolName}}',
    loginToAccount: 'Login to your account',
    mainDomainLoginDescription: 'Login to access all your schools',
    schoolSelectorTitle: 'Your Schools',
    schoolSelectorDescription: 'Select a school to manage its menus and settings',
    createNewSchool: 'Create New School',
    accessAdmin: 'Access Admin',
    delete: 'Delete',
    noSchoolsFound: 'You do not have access to any schools yet.',
    deleteSchool: 'Delete School',
    deleteSchoolConfirmation: 'Are you sure you want to delete',
    deleteSchoolWarning: 'This action cannot be undone.',
    deleting: 'Deleting...',
    creating: 'Creating...',
    createSchool: 'Create School',
    schoolName: 'School Name',
    subdomain: 'Subdomain',
    homepageUrl: 'School Website URL',
    subdomainHelp: 'Only lowercase letters, numbers, and hyphens',
    
    // Pagination specific translations
    pagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      results: 'results',
      previous: 'Previous',
      next: 'Next'
    },
    // Errors (Add new section if it doesn't exist)
    errors: {
      fetchNutrientDetailsFailed: 'Failed to load nutrient details.',
      // Add other generic or specific error keys here as needed
    },
    // Excel Export Headers
    excelHeaders: {
      referenceName: 'Reference Name'
    },
    // Nutrient Tab Specific
    nutrientutils: {
      nutrients: 'Nutriments',
      nutrientDisplaySettings: 'Paramètres d\'Affichage des Nutriments',
      nutritionalInformationExplanation: 'Choisissez si les informations nutritionnelles pour chaque menu quotidien doivent être affichées dans la visionneuse de menu. Si certains plats du menu quotidien n\'ont pas d\'informations nutritionnelles, un message sera affiché indiquant que les informations nutritionnelles ne sont pas disponibles.',
      showNutrients: 'Afficher les informations nutritionnelles dans la visionneuse de menu',
      addNewNutrient: 'Ajouter un Nouveau Nutriment',
      errorLoadingNutrients: 'Erreur lors du chargement des nutriments. Veuillez réessayer plus tard.',
      noNutrientsYet: 'Aucun nutriment n\'a encore été créé.',
      disabled: 'Masqué',
      enabledNutrient: 'Afficher ce nutriment dans la visionneuse de menu',
      editNutrient: 'Modifier le Nutriment',
      deleteNutrient: 'Supprimer le Nutriment',
      deleteNutrientConfirmation: 'Êtes-vous sûr de vouloir supprimer ce nutriment ? Cette action est irréversible.',
      nutrientUpdated: 'Nutriment mis à jour avec succès',
      errorUpdatingNutrient: 'Erreur lors de la mise à jour du nutriment.',
      nutrientDeleted: 'Nutriment supprimé avec succès',
      errorDeletingNutrient: 'Erreur lors de la suppression du nutriment.',
      errorCreatingNutrient: 'Erreur lors de la création du nutriment. Veuillez réessayer.',
      bulkNutrientsTitle: 'Opérations de Nutriments en Masse',
      step1: 'Étape 1 : Exporter le Modèle',
      exportDescription: 'Téléchargez un fichier Excel contenant les plats et les nutriments activés. Vous pouvez exporter uniquement les plats sans nutriments ou tous les plats.',
      exportMissingButton: 'Exporter les Manquants',
      exportAllButton: 'Exporter Tout',
      exportError: 'Erreur lors de l\'exportation des données nutritionnelles : {{error}}',
      step2: 'Étape 2 : Télécharger le Fichier Complété',
      importDescription: 'Remplissez les valeurs nutritionnelles dans le fichier Excel exporté et téléchargez-le ici.',
      selectFileButton: 'Sélectionner le Fichier de Nutriments (.xlsx)',
      validationError: 'Erreur de Validation du Fichier',
      validationErrorDetails: 'Le fichier téléchargé n\'a pas pu être validé en raison du problème suivant :',
      wrongFileFormat: 'Le fichier pourrait être au mauvais format ou structure. Veuillez utiliser le modèle de l\'étape "Exporter".',
      fileStructureExample: 'Le fichier doit avoir les colonnes "ID du Plat", "Nom de Référence", suivies par des colonnes pour chaque nutriment activé (ex. "Énergie (kcal)", "Protéines (g)").',
      tryExportFirst: 'Essayez d\'abord d\'exporter un fichier modèle, puis ajoutez-y vos valeurs nutritionnelles.',
      checkUnits: 'Assurez-vous que les valeurs nutritionnelles correspondent aux unités attendues (si spécifiées dans l\'en-tête).',
      step3: 'Étape 3 : Valider et Importer',
      validateDescription: 'Vérifiez votre fichier téléchargé pour les erreurs avant d\'importer les données.',
      validateImportButton: 'Valider le Fichier',
      itemType: 'Plats',
      confirmImportButton: 'Importer les Nutriments',
      importSuccessMessage: 'Importation des nutriments réussie',
      validationModalTitle: 'Validation de l\'Importation des Nutriments',
      fileEmpty: 'Le fichier semble être vide ou a un format invalide.',
      missingNutrientColumns: 'Colonnes de nutriments requises manquantes : {{message}}',
      invalidNumericValue: 'Valeur numérique invalide trouvée. Les valeurs doivent être des nombres non négatifs.',
      invalidDishId: 'ID de plat invalide trouvé : {{message}}',
      importResults: 'Résultats de l\'Importation',
      importSummary: 'Résumé de l\'opération d\'importation des nutriments',
      validationFailedSummary: 'Le fichier contient des erreurs et ne peut pas être importé.',
      validationSuccessSummary: 'Examinez les modifications ci-dessous avant de confirmer l\'importation.',
      fileName: 'Nom du Fichier',
      dishesToUpdate: 'Plats à Mettre à Jour',
      totalValuesToUpdate: 'Total des Valeurs à Mettre à Jour',
      errorsFound: '{{count}} Erreur(s) Trouvée(s)',
      rowError: 'Ligne {{row}}',
      updatedItemsHeading: 'Valeurs Nutritionnelles à Mettre à Jour',
      dishIdHeader: 'ID du Plat',
      noValue: 'Pas de Valeur',
      fileValid: 'Fichier Validé avec Succès',
      readyToImport: 'Le fichier est prêt à être importé.',
      newValuesHeading: 'Plats avec Nouvelles Valeurs Nutritionnelles ({{count}})',
      changedValuesHeading: 'Plats avec Valeurs Nutritionnelles Modifiées ({{count}})',
      dishesWithUpdates: 'Plats Avec Mises à Jour',
      newValuesCount: 'Nouvelles Valeurs',
      changedValuesCount: 'Valeurs Modifiées',
    },
    tags: {
      displaySettings: 'Paramètres d\'Affichage des Étiquettes',
      showInMenu: 'Afficher les informations sur les étiquettes dans le menu public',
      showInMenuHelp: 'Lorsque cette option est activée, des icônes d\'étiquettes apparaîtront sous les plats dans le menu public avec une légende expliquant chaque étiquette.',
      existing: 'Étiquettes Existantes',
      createNew: 'Créer une Nouvelle Étiquette',
      translations: 'Traductions',
      logo: 'Logo d\'Étiquette',
      uploadLogo: 'Télécharger le logo (optionnel)',
      logoRequirements: 'Taille recommandée : 64x64px. Taille max : 2MB. Formats supportés : JPG, PNG, GIF, SVG, WebP',
      create: 'Créer l\'Étiquette',
      creating: 'Création...',
      editTag: 'Modifier l\'Étiquette',
      deleteConfirmation: 'Supprimer l\'Étiquette',
      deleteWarning: 'Êtes-vous sûr de vouloir supprimer cette étiquette ? Cette action est irréversible.',
      noLogo: 'Aucun logo',
      noTranslation: 'Aucune traduction disponible',
      noLanguages: 'Aucune langue sélectionnée pour cette école. Veuillez ajouter des langues dans l\'onglet Langues.',
      defaultLanguageRequired: 'Traduction dans la langue par défaut requise',
      translationRequired: 'Au moins une traduction est requise',
      fetchError: 'Échec du chargement des étiquettes',
      createSuccess: 'Étiquette créée avec succès',
      createError: 'Échec de la création de l\'étiquette',
      updateSuccess: 'Étiquette mise à jour avec succès',
      updateError: 'Échec de la mise à jour de l\'étiquette',
      deleteSuccess: 'Étiquette supprimée avec succès',
      deleteError: 'Échec de la suppression de l\'étiquette',
      settingUpdateSuccess: 'Paramètre d\'affichage des étiquettes mis à jour',
      settingUpdateError: 'Échec de la mise à jour du paramètre d\'affichage des étiquettes',
      noSchoolId: 'ID de l\'école manquant',
      loadError: 'Erreur lors du chargement des étiquettes',
      empty: 'Aucune étiquette n\'a encore été créée',
      fetchDetailError: 'Échec de la récupération des détails de l\'étiquette',
      legend: 'Légende des Étiquettes',
      noTagsInDish: 'Pas d\'Étiquettes dans ce Plat',
      loading: 'Chargement des étiquettes...',
      notConfiguredWarning: 'Aucune étiquette configurée. Ajoutez d\'abord des étiquettes dans la page Paramètres.',
      queueTitle: 'File d\'Attente des Étiquettes',
      saved: 'Étiquettes enregistrées avec succès',
      saveError: 'Échec de l\'enregistrement des étiquettes',
      selectAtLeastOneOrConfirmNone: 'Veuillez sélectionner au moins une étiquette, ou utiliser le bouton \'Confirmer : Aucune Étiquette\'.',
      dishes: 'Plats',
      noSearchResults: 'Aucun plat ne correspond à votre recherche',
      noDishesNeedTags: 'Aucun plat ne nécessite d\'information sur les étiquettes',
      unsavedChanges: 'Modifications non enregistrées',
      pendingChanges: 'En attente',
      assignFor: 'Attribuer des étiquettes pour',
      confirmNoTags: 'Confirmer : Aucune Étiquette',
      selectTags: 'Sélectionner les étiquettes dans ce plat',
      noTagsConfigured: 'Aucune étiquette n\'est encore configurée pour cette école. Veuillez d\'abord ajouter des étiquettes dans la page Paramètres.',
      selectDish: 'Sélectionnez un plat pour attribuer des étiquettes',
      allDishesComplete: 'Tous les plats ont des informations sur les étiquettes. Excellent travail!'
    },
    'Special Names': 'Noms Spéciaux',
    'Select an item from the list to edit its translations.': 'Sélectionnez un élément de la liste pour modifier ses traductions.',
    ' Nutrient values can also be edited here.': ' Les valeurs nutritionnelles peuvent également être modifiées ici.',
    'Nutrient Values': 'Valeurs Nutritionnelles',
    'No nutrients configured for this school.': 'Aucun nutriment configuré pour cette école.',
    Tags: 'Étiquettes',
    'No Tags in this Dish': 'Aucune Étiquette dans ce Plat',
    usernameOrEmail: 'Nom d\'utilisateur ou Email',
    password: 'Mot de passe',
    loggingIn: 'Connexion en cours...',
    loginSuccess: 'Connexion réussie !',
  },
  queue: {
    individualInput: 'Saisie Individuelle',
    bulkImportExport: 'Importation/Exportation en Masse',
    dishesMissingNutrients: 'Plats Sans Nutriments',
    missing: 'manquant',
    editNutrientsFor: 'Modifier les Nutriments Pour',
    missingNutrients: 'Nutriments Manquants',
    nutrientValuesSaved: 'Valeurs nutritionnelles enregistrées avec succès !',
    errorSavingNutrients: 'Erreur lors de l\'enregistrement des valeurs nutritionnelles',
    enterValue: 'Saisir la valeur',
    skipItem: 'Ignorer l\'Élément',
    deleteDish: 'Supprimer le Plat',
    saveAndNext: 'Enregistrer et Suivant',
    selectDishToEnterNutrients: 'Sélectionnez un plat dans la liste pour saisir les valeurs nutritionnelles',
    nutrientQueueCompleteMessage: 'Tous les plats ont des valeurs nutritionnelles saisies.',
    nutrientQueueCompleteTitle: 'File d\'Attente de Nutriments Terminée !',
    errorLoadingNutrientQueue: 'Erreur lors du chargement de la file d\'attente de nutriments.',
  },
};

export default fr; 